import { TagPicker } from '@all-manager/design-system-v2';
import { ProviderTag } from '../../types';
import { useProviderTagPicker } from './useProviderTagPicker';

type Props = {
  selectedTags: ProviderTag[];
  onChange: (tags: ProviderTag[]) => void;
  triggerButtonText?: string;
  showSelectedTagsInline?: boolean;
};

export default function ProviderTagPicker(props: Props) {
  const hook = useProviderTagPicker();

  return (
    <TagPicker<ProviderTag>
      options={hook.allTags}
      value={props.selectedTags}
      onChange={props.onChange}
      onCreateOption={hook.handleCreateTag}
      triggerButtonText={props.triggerButtonText}
      showSelectedTagsInline={props.showSelectedTagsInline}
      loading={hook.isLoading}
      isCreating={hook.isCreating}
      tagColor="default"
    />
  );
}
